import { render } from "./TimeSelect.vue?vue&type=template&id=27d12fd8"
import script from "./TimeSelect.vue?vue&type=script&lang=js"
export * from "./TimeSelect.vue?vue&type=script&lang=js"
script.render = render

export default script